import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("ap_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ap_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("ap_user", JSON.stringify(r.data)); })
      .catch(() => { localStorage.removeItem("ap_token"); localStorage.removeItem("ap_user"); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  const persist = (token, u) => {
    localStorage.setItem("ap_token", token);
    localStorage.setItem("ap_user", JSON.stringify(u));
    setUser(u);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data.token, data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    persist(data.token, data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ap_token");
    localStorage.removeItem("ap_user");
    setUser(null);
    window.location.href = "/";
  };

  const refresh = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    localStorage.setItem("ap_user", JSON.stringify(r.data));
    return r.data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
